// extracted by mini-css-extract-plugin
module.exports = {"breakpoint-tablet":"(min-width: 520px)","contextualButton":"ContextualFilterButton-module--contextualButton--388928"};